import axios from "axios";
import * as types from "./mutation_types";

export const retrieve = ({ commit }, id) => {
  commit(types.FORMATION_SHOW_TOGGLE_LOADING);

  axios
    .get("/api/formations/" + id + "/")
    .then((response) => {
      commit(types.FORMATION_SHOW_TOGGLE_LOADING);
      commit(types.FORMATION_SHOW_SET_RETRIEVED, response.data);
    })
    .catch((e) => {
      commit(types.FORMATION_SHOW_TOGGLE_LOADING);
      commit(types.FORMATION_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.FORMATION_SHOW_RESET);
};
